import { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { PageHeader } from 'app/components/ui/page-header'
import type { TabType } from 'app/components/Tabs'
import { PAGE_GUTTER, PageGutterContext } from 'app/components/layout/PageScroll'
import { cn } from 'app/lib/utils'

export type TagsManagementShadcnComponentProps = {
  tabs: TabType[]
}

export function TagsManagementShadcnComponent({ tabs }: TagsManagementShadcnComponentProps) {
  const gutter = PAGE_GUTTER[useContext(PageGutterContext)]
  return (
    <div className="flex h-full flex-col">
      <div className={cn(`shrink-0 pt-8`, gutter)}>
        <PageHeader title="Tag Management" tabs={tabs} />
      </div>
      <div className="min-h-0 grow">
        <Outlet />
      </div>
    </div>
  )
}
